'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import TextInput from 'Components/Forms/Elements/TextInput';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
let app = window.app;
export default class ContactForm extends Component {
  state = {
    loading: false,
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  submit = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e?.preventDefault();
    component.setState({
      loading: true
    });
    const data = getFormData({
      state: state,
      pattern: 'contact['
    });
    qwest.post(action('SubmitContact'), data).then(function (xhr, response) {
      component.setState({
        loading: false,
        'contact[content]': '',
        'contact[email]': '',
        'contact[name]': '',
        info: response.info
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-dark']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: "contact-form"
    }, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: action('SubmitContact'),
      className: "contact-form__content",
      onSubmit: component.submit
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "contact-form__input",
      value: state['contact[name]'],
      name: "contact[name]",
      label: "Nom",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "contact-form__input",
      value: state['contact[email]'],
      name: "contact[email]",
      label: "E-mail",
      type: "email",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "contact-form__input",
      value: state['contact[content]'],
      name: "contact[content]",
      label: "Message",
      rows: "4",
      multiline: true,
      status: state.status_messages
    }), getFormStatus(state), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: "c-btn c-btn--full u-margin-top-30"
    }, loader, "Envoyer")));
    return output;
  }
}
